import { StackingRootContext } from '@tableau/widgets';
import React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import { getAppStore } from '~src/app/AppStore';

import { RootAppStateConnector } from '../components/RootAppStateConnector';

export function loadRootApp() {
    const stackingRoot = document.getElementById('app-root');
    ReactDOM.render(
        <StackingRootContext.Provider value={stackingRoot}>
            <Provider store={getAppStore()}>
                <RootAppStateConnector/>
            </Provider>
        </StackingRootContext.Provider>,
        stackingRoot
    );
}